module.exports = __webpack_public_path__ + "static/media/keynote.ea234632.svg";